import { Link } from 'react-router-dom';
import { pricingPlans } from '@/mocks/home';

export default function PricingSection() {
  return (
    <section id="pricing" className="py-20 md:py-28 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-14 md:mb-18">
          <h2 className="text-3xl md:text-4xl font-bold text-foreground-950 mb-4">
            选择适合你的方案
          </h2>
          <p className="text-base text-foreground-600 max-w-xl mx-auto leading-relaxed">
            从个人到企业，灵活定价，按需选择
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-6 md:gap-8 max-w-5xl mx-auto">
          {pricingPlans.map((plan) => (
            <div
              key={plan.name}
              className={`relative rounded-2xl p-6 md:p-8 ${
                plan.popular
                  ? 'bg-primary-500 text-background-50 ring-2 ring-primary-500 ring-offset-2'
                  : 'bg-background-100 text-foreground-900'
              }`}
            >
              {plan.popular && (
                <span className="absolute -top-3 left-1/2 -translate-x-1/2 px-4 py-1 bg-accent-500 text-background-50 text-xs font-semibold rounded-full whitespace-nowrap">
                  最受欢迎
                </span>
              )}

              <h3 className={`text-lg font-semibold mb-1 ${plan.popular ? 'text-background-50' : 'text-foreground-900'}`}>
                {plan.name}
              </h3>
              <p className={`text-sm mb-6 ${plan.popular ? 'text-background-50/70' : 'text-foreground-600'}`}>
                {plan.description}
              </p>

              <div className="mb-6">
                <span className={`text-4xl font-bold ${plan.popular ? 'text-background-50' : 'text-foreground-950'}`}>
                  &yen;{plan.price}
                </span>
                <span className={`text-sm ml-1 ${plan.popular ? 'text-background-50/60' : 'text-foreground-500'}`}>
                  {plan.unit}
                </span>
              </div>

              <ul className="flex flex-col gap-3 mb-8">
                {plan.features.map((feature) => (
                  <li key={feature} className="flex items-start gap-2.5">
                    <i className={`ri-check-line mt-0.5 flex-shrink-0 ${
                      plan.popular ? 'text-background-50' : 'text-primary-600'
                    }`}></i>
                    <span className={`text-sm ${plan.popular ? 'text-background-50/90' : 'text-foreground-700'}`}>
                      {feature}
                    </span>
                  </li>
                ))}
              </ul>

              <Link
                to={plan.ctaHref}
                className={`block w-full py-3 rounded-lg text-center text-sm font-semibold transition-colors whitespace-nowrap ${
                  plan.popular
                    ? 'bg-background-50 text-primary-600 hover:bg-background-100'
                    : 'bg-primary-500 text-background-50 hover:bg-primary-600'
                }`}
              >
                {plan.cta}
              </Link>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}